import { Typography } from '@mui/material';

import type { SxProps } from '@mui/material';

const PremiumFeatureMessage = ({ sx }: { sx?: SxProps }) => (
  <>
    <Typography sx={sx}>This feature isn't included in your plan.</Typography>
    <Typography sx={sx}>Upgrade for advanced functionality.</Typography>
  </>
);

export default PremiumFeatureMessage;
